export default {"src":"https://fishbrain.com/_next/static/media/location.1bee51bb.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};